import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import JudgeCardDialog from "./JudgeCardDialog";
import JudgeNameTable from "./JudgeNameTable";

import configServ from "../../services/config";
import { useSelector } from "react-redux";

const JudgeNamePage = () => {
  const { company_id } = useSelector((state) => state.GlobalVariables);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [editData, setEditData] = useState(null);

  const [judgeNames, setJudgeNames] = useState([]);

  const [search, setSearch] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ================= FETCH =================

  const fetchJudgeNames = async () => {
    try {
      const payload = {
        company_id: company_id,
      };

      const result = await configServ.getAllJudgeNames(payload);

      if (result?.data) {
        setJudgeNames(result.data);
      } else {
        setJudgeNames([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchJudgeNames();
  }, []);

  // ================= POPUP =================

  const handlePopup = () => {
    setIsCreate(!isCreate);

    if (isCreate) {
      setIsEdit(false);
      setEditData(null);
    }
  };

  // ================= EDIT =================

  const handleEdit = (row) => {
    setEditData(row);
    setIsEdit(true);
    setIsCreate(true);
  };

  // ================= DELETE =================

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this Judge?")) return;

    try {
      await configServ.deleteJudgeName({
        id: id,
      });

      fetchJudgeNames();
    } catch (error) {
      console.log(error);
    }
  };

  // ================= SEARCH =================

  const filteredJudge = judgeNames.filter((item) =>
    item.judge_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container-fluid px-3">

      {/* Heading */}
      <div className="row">
        <div className="col-12">

          <CardHeadMenu
            prefix="Na"
            suffix="Na"
            title="JUDGE NAME REGISTRATION"
            handlePopup={handlePopup}
            create={isCreate}
            isEdit={isEdit}
            setEditData={setEditData}

          />

        </div>
      </div>

      {/* Table */}
      <div className="row mt-2">
        <div className="col-12">

          <JudgeNameTable
            judgeNames={filteredJudge}
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
            search={search}
            setSearch={setSearch}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />

        </div>
      </div>

      <AnimatePresence>
        {isCreate && (
          <JudgeCardDialog
            isEdit={isEdit}
            editData={editData}
            handlePopup={handlePopup}
            refreshData={fetchJudgeNames}
            company_id={company_id}
            setIsEdit = {setIsEdit}
            setEditData = {setEditData}
          />
        )}
      </AnimatePresence>

    </div>
  );
};

export default JudgeNamePage;